class ColllectionGrid extends HTMLElement {
    constructor() {
        super();

        console.log('coucou');
        this.filters_buttons = this.querySelectorAll('[data-filter-tag]');
        this.products_cards = this.querySelectorAll('[data-product-tag]');

        this.filters_buttons.forEach((button) => {
            button.addEventListener('click', this.changeCollection.bind(this));
        });

        this.filter_value = this.findGetParameter('data-filter');

        if (this.filter_value) {
            this.querySelectorAll('.filters .custom-button-small').forEach((link) => {
                if (link.getAttribute('data-filter-tag') == this.filter_value) {
                    link.click()
                }
            })
        }

    }

    changeCollection(e) {

        this.filters_buttons.forEach((button) => {
            button.classList.remove('actif');
        });
        const tag = e.currentTarget.dataset.filterTag;
        e.currentTarget.classList.add('actif');


        if (tag == "all") {
            this.products_cards.forEach((card) => { card.classList.remove('hidden') });
        } else {
            this.products_cards.forEach((card) => {
                const product_tags = card.dataset.productTag.split(',');
                if (product_tags.includes(tag)) {
                    card.classList.remove('hidden');
                } else {
                    card.classList.add('hidden');
                }
            });
        }
    }

    findGetParameter(parameterName) {
        let queryString = window.location.search;

        if (queryString) {
            let urlParams = new URLSearchParams(queryString);

            let nom = urlParams.get(parameterName);

            return nom;
        }

    }
}

customElements.define('collection-grid', ColllectionGrid);